import React from 'react';
import { Modal } from 'react-bootstrap';

interface Props {
    show    : boolean;
    title   : any;
    onHide  : any;
    size?   : "sm" | "md" | "lg" | "xl" | undefined;
    children: any;
    bodyClassName?: string;
    dialogClassName?: string;
}

function MyModal({ show, title, children, onHide, size = "lg", bodyClassName, dialogClassName }: Props) {
    const bootstrapSize = size === "md" ? undefined : size;

    return (
        <Modal
            show={show}
            animation={true}
            onHide={onHide}
            size={bootstrapSize}
            dialogClassName={dialogClassName}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3>{title}</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={bodyClassName}>{children}</Modal.Body>
        </Modal>
    );
}

export default MyModal;